import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'features/auth/authSelectors';
import { hasPermission } from 'utils/permissions';
import { ACTIONS } from 'constants/permissions';
import { ROUTES } from 'constants/routes';

/**
 * Module and action-level route gate. Access is driven by the user's accessible modules,
 * which come from the backend. A user who cannot access a module/action is redirected 
 * to the 403 page even via direct URL.
 */
const RoleRoute = ({ module, action = ACTIONS.VIEW }) => {
  const user = useSelector(selectCurrentUser);

  if (!hasPermission(user, module, action)) {
    return <Navigate to={ROUTES.FORBIDDEN} replace />;
  }
  return <Outlet />;
};

export default RoleRoute;
